import React from 'react';
import PropTypes from 'prop-types';

function DashboardCardSkeleton({ count = 3 }) {
    return (
        <>
            {Array.from({ length: count }, (_, index) => (
                <div
                    key={`dashboard-card-skeleton-${index}`}
                    className="dashboard-card-skeleton"
                    aria-hidden="true"
                >
                    <div className="dashboard-card-skeleton-header" />
                    <div className="dashboard-card-skeleton-image" />
                    <div className="dashboard-card-skeleton-metrics">
                        <div className="dashboard-card-skeleton-line" />
                        <div className="dashboard-card-skeleton-line dashboard-card-skeleton-line-short" />
                    </div>
                </div>
            ))}
        </>
    );
}

DashboardCardSkeleton.propTypes = {
    count: PropTypes.number,
};

export default DashboardCardSkeleton;
